import { render, staticRenderFns } from "./ContractAttachments.view.vue?vue&type=template&id=4abb3f28&"
import script from "./ContractAttachments.view.vue?vue&type=script&lang=js&"
export * from "./ContractAttachments.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4abb3f28')) {
      api.createRecord('4abb3f28', component.options)
    } else {
      api.reload('4abb3f28', component.options)
    }
    module.hot.accept("./ContractAttachments.view.vue?vue&type=template&id=4abb3f28&", function () {
      api.rerender('4abb3f28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/contract/ContractAttachments.view.vue"
export default component.exports